import { ResearchProjectResult } from "interface/research"
import { Dialog } from "@mui/material"
import { ResearchPreview } from '../../preview'

type ResearchPreviewDialogProps = {
  projectList?: ResearchProjectResult[]
  projectKey?: string | null
	project?: ResearchProjectResult | null
  targetSisetuCode?: string
  targetKojinCode?: string
	onSisetuOpen?: (sisetuCode: string | null) => void
  onKojinOpen?: (kojinCode: string | null) => void
  onClose: () => void
}
export const ResearchPreviewDialog = ({
  projectList,
  projectKey,
  project,
  targetSisetuCode,
  targetKojinCode,
  onSisetuOpen,
  onKojinOpen,
  onClose
}: ResearchPreviewDialogProps) => {
  return (
    <Dialog
      open
      fullWidth
      maxWidth="lg"
      onClose={() => onClose()}
    >
      <ResearchPreview
        projectList={projectList}
        projectKey={projectKey}
        project={project}
        targetSisetuCode={targetSisetuCode}
        targetKojinCode={targetKojinCode}
        onSisetuOpenReply={onSisetuOpen}
        onKojinOpenReply={onKojinOpen}
        onClose={onClose}
        sx={{ height: '90vh' }}
      />
    </Dialog>
  )
}
